import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./views/home";
import Crud from "./views/crud";
import Program from "./views/program";

import "./assets/styles/main.scss";

const baseURL = "https://api.bsitescomp.com/api/softwaregratisya";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home baseURL={baseURL} />} />
        <Route path="/crud" element={<Crud baseURL={baseURL} />} />
        <Route path="/program" element={<Program baseURL={baseURL} />} />
      </Routes>
    </Router>
  );
}

export default App;
